const STAR_PATH =
  'M256 47C264 47 267 174 273 205C276 219 280 223 288 216L350 160C353 158 354 159 352 162L297 224C289 233 291 238 305 241L455 254C465 255 465 257 455 259L305 271C291 274 289 279 297 288L352 350C354 353 353 354 350 352L288 297C279 289 274 291 271 305L259 455C257 465 255 465 254 455L241 305C238 291 233 289 224 297L162 352C159 354 158 353 160 350L216 288C223 280 219 276 205 273L55 259C45 257 45 255 55 254L205 241C219 238 223 234 216 226L160 162C158 159 159 158 162 160L224 216C232 223 236 219 239 205L252 55C253 50 254 47 256 47Z';

/**
 * Брендовая заставка приложения. Это наш экран внутри WebView, а не
 * системный placeholder Telegram: поэтому фирменные цвета сохраняются
 * без перекрашивания со стороны хоста.
 */
export function BrandSplash() {
  return (
    <main className="brand-splash" role="status" aria-label="Приложение загружается">
      <svg
        className="brand-splash__mark"
        viewBox="0 0 512 512"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="256" cy="256" r="154" fill="none" stroke="currentColor" strokeWidth="8" />
        <path d={STAR_PATH} fill="currentColor" />
      </svg>
      <span className="sr-only">Загружаем студию…</span>
    </main>
  );
}
